// extracted by mini-css-extract-plugin
export var errorIcon = "_mj-1";
export var nameLogo = "_mj-0";